<template>
  <div v-if="show">
    <div class="batch-header">
      <div class="batch-header-left">
        <a-icon class="batch-close" type="close" @click="onCloseClick" />
      </div>
      <div class="batch-title">{{$t('common.hasSelect')+selectedKeys.length+$t('common.selectedUnit')}}</div>
      <div class="batch-header-right">
        <a class="batch-all" @click="onAllClick">{{$t('actionTitles.selectAll')}}</a>
      </div>
    </div>
    <div class="batch-footer">
      <slot></slot>
    </div>
  </div>
</template>
<style lang="less" scoped>
.batch-header {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 46px;
  background: #fff;
  position: fixed;
  z-index: 1000;
  top: 0;
  border-bottom: 0.5px solid #efeeee;

  .batch-header-left {
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 16px;
    font-size: 14px;
    cursor: pointer;
  }
  .batch-header-title {
    width: 100%;
    text-align: center;
    font-size: 16px;
    line-height: 46px;
    color: #666;
  }
  .batch-header-right {
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 16px;
    font-size: 14px;
    cursor: pointer;
  }
}

.batch-footer {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 50px;
  background: #fff;
  position: fixed;
  z-index: 1000;
  bottom: 0;
  padding: 5px;
  border-top: 0.5px solid #efeeee;
}
</style>

<script>
export default {
  props: {
    selectedKeys: {
      type: Array,
      required: true,
    },
  },
  computed: {
    show() {
      return this.selectedKeys.length > 0;
    },
  },
  methods: {
    onCloseClick() {
      this.$emit("close");
    },
    onAllClick() {
      this.$emit("all");
    },
  },
};
</script>